import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse, isAxiosError } from 'axios';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { httpGET, httpPOST } from '../../services/http.ts';
import { AcceptInvitationRequest, GetInvitationRequest, Invitation } from '../../types/invitation.ts';
import { invitationReducer } from '../reducers/invitation.reducer.ts';
import { toastReducer } from '../reducers/toast.reducer.ts';
import { history } from '../store.ts';

const { getInvitation, setInvitation, setInvitationError, acceptInvitation, setAcceptSuccess, setAcceptError } =
  invitationReducer.actions;

const { showToast } = toastReducer.actions;

function* getInvitationAction(action: PayloadAction<GetInvitationRequest>) {
  try {
    const { data }: AxiosResponse<Invitation> = yield call(httpGET, `/invitations/token/${action.payload.token}`);
    yield put(setInvitation(data));
  } catch (error: unknown) {
    let errorMessage = 'invitation.toast.loadInvitationError';
    if (isAxiosError(error) && error.response?.data) {
      errorMessage = error.response.data;
    }
    yield put(setInvitationError(errorMessage));
    yield put(
      showToast({
        message: errorMessage,
        type: 'error',
      }),
    );
  }
}

function* acceptInvitationAction(action: PayloadAction<AcceptInvitationRequest>) {
  try {
    yield call(httpPOST, '/invitations/accept', action.payload);
    yield put(setAcceptSuccess(true));
    yield put(
      showToast({
        message: 'invitation.toast.acceptSuccess',
        type: 'success',
      }),
    );
    // Redirect to home page after successful acceptance
    setTimeout(() => {
      history.push('/');
    }, 2000);
  } catch (error: unknown) {
    let errorMessage = 'invitation.toast.acceptError';
    if (isAxiosError(error) && error.response?.data) {
      errorMessage = error.response.data;
    }
    yield put(setAcceptError(errorMessage));
    yield put(
      showToast({
        message: errorMessage,
        type: 'error',
      }),
    );
  }
}

export default function* invitationSaga() {
  yield all([takeLatest(getInvitation, getInvitationAction)]);
  yield all([takeEvery(acceptInvitation, acceptInvitationAction)]);
}
